import { useTheme, useMediaQuery } from '@mui/material';
import Link from 'next/link'
import theme from "../theme"
import { useRouter } from "next/router"
import styles from "../../styles/Header.module.css"
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

function Button({ title, url }: { title: string; url: string }) {
	const router = useRouter()
	const active = router.pathname === url

	return (
		<li className={styles.button}
			style={{
				backgroundColor: active ? "rgb(255,132,0)" : undefined,
				color: active ? "black" : "white"
			}}>
			<Link href={url}>
				<div>
					{title}
				</div>
			</Link>
		</li>
	)
}

function SetLink({ href, title }: { href: string; title: string }) {
	const router = useRouter();
	const current = router.pathname === href;

	return (
		<Link href={href} style={{ opacity: current ? 0.56 : 1 }}>
			{title}
		</Link>
	);
}

function MenuItems() {
	return (
		<>
			<li>
				<SetLink href="/Bemutatkozas" title="Bemutatkozás" />
			</li>
			<li>
				<SetLink href="/Applikacio" title="Applikáció" />
			</li>
			<li>
				<Link href="/Telepulesek">Települések</Link>
			</li>
			<li>
				<Link href="/Media">Média megjelenések</Link>
			</li>
		</>
	)
}

export default function Header() {
	const theme = useTheme();
	const largeScreen = useMediaQuery(theme.breakpoints.up('md'));
	const router = useRouter();

	return (

		<>
			<div style={{ height: "2rem" }} />
			<nav className={styles.nav}>
				<ul>
					<li>
						<div className={styles.line}></div>
						<h2 className={styles.motto}>
							HolmiApp, a települési applikáció
						</h2>
					</li>
					{!largeScreen && <li style={{ flexGrow: 1 }}></li>}
					{largeScreen ?
						<>
							<Button title="Kezdőoldal" url="/" />
							<Button title="Bemutató" url="/Bemutato" />
							<Button title="Elérhetőség" url="/Elerhetoseg" />
							<Button title="Települések" url="/Telepulesek" />
							<Button title="Önkormányzat" url="/Onkormanyzat" />
						</> :
						<li className={styles.right}>
							<Link href={router.pathname === "/Menu" ? "javascript:history.back()" : "Menu"}>
								<IconButton
									edge="start"
									aria-label="Menü"
								>
									{router.pathname === "/Menu" ? <CloseIcon /> : <MenuIcon />}
								</IconButton>
							</Link>
						</li>
					}
				</ul>
			</nav>
		</>
	)
}